import React, { useState, useEffect, FormEvent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { InputSearch, MobileInputSearch } from './styled'
import { selectNft, changeSearch } from 'state/nft/slice'
import useDebounce from 'hooks/useDebounce'
import { selectNftFavorites } from 'state/nftFavorites/slice'
import fetchNft from 'state/nft/actions/fetchNft'
import fetchFavoritedNft from 'state/nft/actions/fetchFavoritedNft'

function SearchInput({ mobile }: { mobile?: boolean }) {
  const dispatch = useDispatch()
  const nft = useSelector(selectNft)
  const [search, setSearch] = useState(nft.search)
  const searchDebounced = useDebounce(search, 300)
  const [ready, setReady] = useState(false)
  const { favoriteMode } = useSelector(selectNftFavorites)

  const onSubmitHandler = (e: FormEvent<any>) => {
    e.preventDefault()
    e.currentTarget[0].blur()
  }

  useEffect(() => {
    if (!nft.isFirstTimeLoad && ready) {
      dispatch(changeSearch(searchDebounced))
      if (favoriteMode) {
        dispatch(fetchFavoritedNft())
      } else {
        dispatch(fetchNft())
      }
    }

    setReady(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, searchDebounced])

  return (
    <form onSubmit={onSubmitHandler}>
      {mobile ? (
        <MobileInputSearch
          type="search"
          placeholder="Search NFTs"
          value={search}
          onChange={e => setSearch(e.target.value)}
          defaultValue={nft.search}
        />
      ) : (
        <InputSearch
          type="search"
          placeholder="Search NFTs"
          value={search}
          onChange={e => setSearch(e.target.value)}
          defaultValue={nft.search}
        />
      )}
    </form>
  )
}

export default SearchInput
